import { render, staticRenderFns } from "./AdmissionDashboard.vue?vue&type=template&id=a5ce704e&scoped=true"
import script from "./AdmissionDashboard.vue?vue&type=script&lang=js"
export * from "./AdmissionDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdmissionDashboard.vue?vue&type=style&index=0&id=a5ce704e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ce704e",
  null
  
)

export default component.exports